import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactNode } from "react"

// Create QueryClient outside component to prevent recreation on every render
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 2 * 60 * 1000,    // 2 minutes default
      cacheTime: 5 * 60 * 1000,    // 5 minutes cache
      networkMode: 'online',
    }
  }
})

export default function ReactQueryProvider({children} : {children: ReactNode}) {

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  )
}